export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/qrcode.worker.a838d9b5.worker.js");
}
